const Holidays = (() => {
    var holidaysTable;
    var activeVendors = [];
    // The holiday currently open in the form, or null when adding a new one.
    var editingHoliday = null;
    var formPopup;
    var pageLoadPopup;

    function formatDateForDisplay(isoDate) {
        if (!isoDate) return '';
        return moment(isoDate, 'YYYY-MM-DD').format('MM/DD/YYYY');
    }

    function showProgressPopup(message) {
        pageLoadPopup = POPUP.build({ hideX: true });
        pageLoadPopup.style.minHeight = '40%';
        const spinner = PROGRESS.SPINNER.get(message);
        spinner.style.display = 'block';
        pageLoadPopup.appendChild(spinner);
        POPUP.show(pageLoadPopup);
    }
    function hideProgressPopup() {
        if (pageLoadPopup) POPUP.hide(pageLoadPopup);
    }

    async function populateHolidaysTable() {
        const result = await _UTIL.fetchData('getHolidays', { token: $.session.Token });
        const holidayList = result.getHolidaysResult || [];

        const tableData = holidayList.map(holiday => {
            return {
                id: `${holiday.vendorId}|${holiday.holidayDate}`,
                values: [
                    formatDateForDisplay(holiday.holidayDate),
                    holiday.description,
                    holiday.vendorName,
                ],
                endIcon: $.session.SetupDelete === true ? icons['delete'] : icons['empty'],
                endIconCallback: e => {
                    e.stopPropagation();
                    if ($.session.SetupDelete === true) {
                        showDeleteWarning(holiday);
                    }
                },
                onClick: e => {
                    if (!e.target.classList.contains('endIcon')) {
                        showHolidayForm(holiday);
                    }
                },
            };
        });

        table.populate(holidaysTable, tableData);
    }

    function toggleError(element, hasError) {
        if (hasError) {
            element.classList.add('error');
        } else {
            element.classList.remove('error');
        }
    }

    function validateForm() {
        const dateEle = document.getElementById('holidayDate');
        const descEle = document.getElementById('description');
        const vendorEle = document.getElementById('vendorId');
        if (!dateEle || !descEle || !vendorEle) return;

        const dateVal = dateEle.value;
        const descVal = descEle.value.trim();
        const vendorVal = vendorEle.value;

        toggleError(dateEle, !dateVal);
        toggleError(descEle, !descVal);
        toggleError(vendorEle, !vendorVal);

        const allValid = dateVal && descVal && vendorVal;

        // On edit the Save button also requires an actual change.
        let isChanged = true;
        if (editingHoliday) {
            isChanged =
                dateVal !== editingHoliday.holidayDate ||
                descVal !== (editingHoliday.description || '').trim() ||
                vendorVal !== String(editingHoliday.vendorId);
        }

        const permitted = editingHoliday ? $.session.SetupUpdate : $.session.SetupInsert;
        const saveBtn = document.getElementById('saveHolidayBtn');
        if (allValid && isChanged && permitted) {
            saveBtn.classList.remove('disabled');
            saveBtn.disabled = false;
        } else {
            saveBtn.classList.add('disabled');
            saveBtn.disabled = true;
        }
    }

    function showHolidayForm(holiday) {
        editingHoliday = holiday || null;

        const dateInput = new Input({
            label: 'Date',
            type: 'date',
            id: 'holidayDate',
            value: editingHoliday ? editingHoliday.holidayDate : '',
            required : true
        });
        const descriptionInput = new Input({
            label: 'Description',
            type: 'text',
            id: 'description',
            maxlength: 50,
            value: editingHoliday ? editingHoliday.description : '',
            required: true
        });
        const vendorSelect = new Select({
            label: 'Vendor',
            id: 'vendorId',
            data: activeVendors.map(v => ({ ...v })),
            includeBlankOption: true,
            required: true
        });
        if (editingHoliday) {
            vendorSelect.setValue(String(editingHoliday.vendorId));
        }

        formPopup = POPUP.build({ hideX: true, classNames: 'holidayPopup' });

        const container = document.createElement('div');
        container.id = 'holidayForm';
        container.appendChild(dateInput.rootElement);
        container.appendChild(descriptionInput.rootElement);
        container.appendChild(vendorSelect.rootElement);

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');

        const saveBtn = button.build({
            id: 'saveHolidayBtn',
            text: ' Save',
            icon: ['save'],
            style: 'secondary',
            type: 'contained',
            callback: submitHoliday,
        });
        const cancelBtn = button.build({
            id: 'cancelHolidayBtn',
            text: 'Cancel',
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                editingHoliday = null;
                POPUP.hide(formPopup);
            },
        });

        btnWrap.appendChild(saveBtn);
        btnWrap.appendChild(cancelBtn);
        container.appendChild(btnWrap);
        formPopup.appendChild(container);
        POPUP.show(formPopup);

        // Wire validation. Disable the fields entirely when the user lacks the
        // Update key (read-only view of an existing holiday).
        const fields = [dateInput.input || document.getElementById('holidayDate'),
                        descriptionInput.input || document.getElementById('description'),
                        vendorSelect.select];
        const canEdit = editingHoliday ? $.session.SetupUpdate : $.session.SetupInsert;
        fields.forEach(field => {
            if (!canEdit) {
                field.disabled = true;
                field.classList.add('disabled');
            } else {
                field.addEventListener('input', validateForm);
                field.addEventListener('change', validateForm);
            }
        });

        validateForm();
    }

    async function submitHoliday() {
        const saveBtn = document.getElementById('saveHolidayBtn');
        const cancelBtn = document.getElementById('cancelHolidayBtn');
        saveBtn.classList.add('disabled');
        saveBtn.disabled = true;
        cancelBtn.classList.add('disabled');

        const payload = {
            isEdit: editingHoliday ? 'Y' : 'N',
            originalVendorId: editingHoliday ? String(editingHoliday.vendorId) : '',
            originalDate: editingHoliday ? editingHoliday.holidayDate : '',
            vendorId: document.getElementById('vendorId').value,
            holidayDate: document.getElementById('holidayDate').value,
            description: document.getElementById('description').value.trim(),
        };

        showProgressPopup('Saving Holiday...');
        let saveResult;
        try {
            const result = await _UTIL.fetchData('saveHoliday', { token: $.session.Token, holiday: payload });
            saveResult = result.saveHolidayResult;
        } catch {
            saveResult = 'exception';
        }
        hideProgressPopup();

        if (saveResult === 'success') {
            POPUP.hide(formPopup);
            editingHoliday = null;
            successfulSave.show('Saved');
            await populateHolidaysTable();
            setTimeout(() => { successfulSave.hide(); }, 2000);
        } else if (saveResult === 'duplicate') {
            showAlreadyExistsWarning('This holiday already exists.');
        } else if (saveResult === 'Error:606' || saveResult === 'Error:607') {
            failSave.show('Your session has expired. Please log in and try again.');
            setTimeout(() => { failSave.hide(); }, 2000);
            reenableFormButtons();
        } else {
            failSave.show('An error occured.');
            setTimeout(() => { failSave.hide(); }, 2000);
            reenableFormButtons();
        }
    }

    function reenableFormButtons() {
        const cancelBtn = document.getElementById('cancelHolidayBtn');
        if (cancelBtn) cancelBtn.classList.remove('disabled');
        validateForm();
    }

    function showAlreadyExistsWarning(msg) {
        const warningPopup = POPUP.build({ hideX: true});
        warningPopup.classList.add('warning');
        const message = document.createElement('p');
        message.innerHTML = msg;
        message.style.marginBottom = '15px';
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        const okBtn = button.build({
            text: 'Ok',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(warningPopup);
                const overlay = document.querySelector('.overlay');
                if (overlay) overlay.classList.add('visible');
                reenableFormButtons();
            },
        });
        btnWrap.appendChild(okBtn);
        warningPopup.appendChild(message);
        warningPopup.appendChild(btnWrap);
        POPUP.show(warningPopup);
        const closeBtn = warningPopup.querySelector('.closePopupBtn');
        if (closeBtn) closeBtn.remove();
    }

    function showDeleteWarning(holiday) {
        const deletePopup = POPUP.build({ hideX: true});
        const message = document.createElement('p');
        message.innerHTML = 'Are you sure you want to delete this holiday?';
        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        btnWrap.style.marginTop = '25px';

        const yesBtn = button.build({
            text: 'Yes',
            type: 'contained',
            style: 'secondary',
            callback: async () => {
                POPUP.hide(deletePopup);
                showProgressPopup('Deleting Holiday...');
                let deleteResult;
                try {
                    const result = await _UTIL.fetchData('deleteHoliday', {
                        token: $.session.Token,
                        vendorId: String(holiday.vendorId),
                        holidayDate: holiday.holidayDate,
                    });
                    deleteResult = result.deleteHolidayResult;
                } catch {
                    deleteResult = 'exception';
                }
                hideProgressPopup();
                if (deleteResult === 'success') {
                    successfulSave.show('Deleted');
                    await populateHolidaysTable();
                    setTimeout(() => { successfulSave.hide(); }, 2000);
                } else {
                    failSave.show('An error occured.');
                    setTimeout(() => { failSave.hide(); }, 2000);
                }
            },
        });
        const noBtn = button.build({
            text: 'No',
            type: 'contained',
            style: 'secondary',
            callback: () => {
                POPUP.hide(deletePopup);
            },
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        deletePopup.appendChild(message);
        deletePopup.appendChild(btnWrap);
        POPUP.show(deletePopup);
    }

    async function getView() {
        const activeVendorsResult = await _UTIL.fetchData('getActiveVendors', { token: $.session.Token });
        activeVendors = activeVendorsResult.getActiveVendorsResult || [];

        const viewMarkup = document.createDocumentFragment();

        holidaysTable = table.build({
            tableId: 'holidaysTable',
            columnHeadings: ['Date', 'Description', 'Vendor'],
            endIcon: true,
        });

        // Set the data type for each header for client-side sorting.
        const headers = holidaysTable.querySelectorAll('.header div');
        headers[0].setAttribute('data-type', 'date');   // Date
        headers[1].setAttribute('data-type', 'string'); // Description
        headers[2].setAttribute('data-type', 'string'); // Vendor
        table.sortTableByHeader(holidaysTable);

        await populateHolidaysTable();

        const btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        const addNewHolidayBtn = button.build({
            id: 'addNewHolidayBtn',
            text: 'add new holiday',
            icon: ['add'],
            style: 'secondary',
            type: 'outlined',
            callback: () => {
                showHolidayForm(null);
            },
        });
        addNewHolidayBtn.style.padding = '6px';
        addNewHolidayBtn.style.marginTop = '20px';
        if ($.session.SetupInsert) {
            btnWrap.appendChild(addNewHolidayBtn);
        }

        const header = document.createElement('h1');
        header.classList.add('viewHeading');
        header.textContent = 'Holidays';

        viewMarkup.appendChild(header);
        viewMarkup.appendChild(holidaysTable);
        viewMarkup.appendChild(btnWrap);

        return viewMarkup;
    }

    return {
        getView,
    };
})();
